import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { Receipt, Sparkles } from "lucide-react";
import { useSystemSettings, useFeatureEnabled } from "../../lib/systemSettings";

function euro(cents) { return `€ ${(Number(cents ?? 0) / 100).toFixed(2)}`; }

export default function PortalPurchases() {
  const { brandName } = useSystemSettings();
  const pointsOn = useFeatureEnabled("points");
  const q = useQuery({
    queryKey: ["portal-orders"],
    queryFn: async () => (await api.get("/portal/orders")).data,
  });
  const orders = q.data || [];
  return (
    <div className="space-y-4" data-testid="portal-purchases">
      <div>
        <div className="text-3xl font-black uppercase tracking-tight">Meine Einkäufe</div>
        <div className="text-sm text-zinc-500">Deine abgeschlossenen {brandName}-Käufe.</div>
      </div>
      {q.isLoading && <div className="text-zinc-500">Lade…</div>}
      {!q.isLoading && orders.length === 0 && (
        <div className="border border-dashed border-zinc-800 rounded-sm p-8 text-center text-zinc-500">
          Noch keine Käufe.
        </div>
      )}
      <div className="grid gap-3">
        {orders.map((o) => {
          const ts = new Date(o.paid_at || o.created_at);
          return (
            <div key={o.id} data-testid={`portal-order-${o.id}`}
                 className="border border-zinc-800 rounded-lg p-4 bg-zinc-900">
              <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
                <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-cyan-400">
                  <Receipt size={14} />
                  <span>{ts.toLocaleDateString("de-DE")} · {ts.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" })}</span>
                  {o.location_name && <span className="text-zinc-500">· {o.location_name}</span>}
                </div>
                <div className="font-mono font-black text-lg">{euro(o.total_cents)}</div>
              </div>
              <div className="text-xs divide-y divide-zinc-800">
                {(o.lines || []).map((l, i) => (
                  <div key={i} className="flex justify-between py-1">
                    <span className="text-zinc-300">{l.quantity}× {l.product_name || "—"}</span>
                    <span className="font-mono text-zinc-400">{euro(l.line_total_cents)}</span>
                  </div>
                ))}
              </div>
              {pointsOn && o.points_awarded > 0 && (
                <div className="mt-3 flex items-center gap-1 text-cyan-400 text-xs uppercase tracking-wider truncate">
                  <Sparkles size={12} /> +{o.points_awarded} {brandName} Punkte
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
